"use client";
import * as React from "react";
const SvgBilholdSymbol = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.0008 8.51847V11.9349C13.2932 11.9349 14.3352 12.9768 14.3352 14.2592C14.3352 15.5416 13.2832 16.5836 12.0008 16.5836C10.7184 16.5836 9.66642 15.5416 9.66642 14.2592V4H6.22998V14.2592C6.22998 17.4252 8.82485 20 12.0008 20C15.1768 20 17.7716 17.4252 17.7716 14.2592C17.7716 11.0933 15.1768 8.51847 12.0008 8.51847Z", fill: "currentColor" }));
export {
  SvgBilholdSymbol as default
};
